import React from "react";
import ChevronsRightIcon from "../../../shared-components/icons/ChevronsRightIcon";
import { useRaffleContext } from "../context";
import EarnPointsContent from "./EarnPointsContent";
import { EARN_POINTS_COLORS } from "../utils";

export function EarnPoints() {
  const {
    activeCompetitionsLoading,
    onCompetitionClick,
    activeCompetitions,
    howToPlayClick,
    setPointsByCompetitionType,
    showAllCompetitions,
    seeAllCompetitionsClick,
    hasSubscription,
  } = useRaffleContext();

  return (
    <div className={"bg-white px-3 max-lg:pt-8 lg:py-8 font-jost overflow-hidden"}>
      <div className={"flex flex-col gap-6 items-center lg:max-w-[1340px] lg:mx-auto lg:gap-8"}>
        <div className={"uppercase text-center text-dark-1 font-bold text-lg leading-6 lg:text-2xl lg:leading-7.5"}>
          JUST ENTER & COLLECT TICKETS
        </div>

        <div className={"lg:max-w-[956px] lg:grid lg:grid-cols-2 lg:gap-[72px] lg:items-center"}>
          <div className={"mb-3 text-gray-1 text-center font-normal text-sm leading-5 lg:text-lg lg:leading-6"}>
            Simply enter as usual and automatically earn draw tickets. The more you play, the more chances you have.
          </div>

          <div className="relative overflow-hidden lg:w-full lg:max-w-[442px] lg:mx-auto bg-[#F5F5F5] rounded-lg">
            {/* <div className="absolute top-0 left-0 px-1.5 lg:px-2 py-0.5 lg:py-[3px] bg-gradient-botb rounded-br-lg">
              <div className="text-[10px] lg:text-xs font-medium leading-[12px] lg:leading-4 text-white whitespace-nowrap">
                SUBSCRIBERS ONLY
              </div>
            </div> */}

            <div className="flex items-center justify-between min-h-14 lg:min-h-[100px] px-2 lg:px-4 py-3 lg:py-4 gap-2 lg:gap-3">
              <div className="flex items-center min-w-0 gap-2 lg:gap-3">
                <img
                  src="/assets/images/big-7-draws/botb-pass-entries.webp"
                  alt="BOTB Pass"
                  className="shrink-0 w-[60px] h-6 lg:w-20 lg:h-8 object-contain"
                />
                {/* <img src="/assets/images/leaderboard/2x.webp" alt="2x points" className="shrink-0 w-10 lg:w-[64px]" /> */}
                <div className="min-w-0 text-xs font-medium leading-4 lg:text-base lg:leading-[22px] text-secondary">
                  Subscribers earn <span className="font-bold">DOUBLE ENTRIES on all tickets!</span>
                </div>
              </div>

              {!hasSubscription ? (
                <a
                  href="/botb-pass?utm_medium=leaderboard-everybody-wins"
                  className="flex items-center justify-center shrink-0 min-h-8 lg:min-h-10 px-2.5 py-1 text-xs lg:text-base font-medium leading-normal lg:leading-5.5 text-center whitespace-nowrap bg-[#3268E8] text-white rounded-lg cursor-pointer">
                  Subscribe now
                </a>
              ) : null}
            </div>
          </div>
        </div>

        <div className={"w-full lg:grid lg:grid-cols-3 lg:gap-x-[56px] lg:gap-y-2.5"}>
          <EarnPointsContent
            activeCompetitions={activeCompetitions}
            activeCompetitionsLoading={activeCompetitionsLoading}
            onCompetitionClick={onCompetitionClick}
            setPointsByCompetitionType={setPointsByCompetitionType}
            showAllCompetitions={showAllCompetitions}
            COLORS={EARN_POINTS_COLORS}
          />
        </div>

        <div className={"flex-center flex-col gap-3 lg:gap-4 pb-8 lg:pb-10"}>
          <button
            onClick={seeAllCompetitionsClick}
            title={"SEE ALL COMPETITIONS"}
            className={"theme-btn theme-btn-primary uppercase min-w-[222px] gap-1.5 lg:min-w-[254px]"}>
            {`VIEW ALL (${activeCompetitions.length})`}
            <ChevronsRightIcon variant={4} className={"text-white size-4 lg:size-5 shrink-0"} />
          </button>
          <button
            onClick={howToPlayClick}
            title={"HOW IT WORKS"}
            className={
              "theme-btn theme-btn-link underline !text-gray-5 gap-1.5 theme-btn-xs lg:theme-btn-lg uppercase lg:text-sm font-medium"
            }>
            {`HOW IT WORKS`}
            <ChevronsRightIcon variant={4} className={"size-4 shrink-0"} />
          </button>
        </div>
      </div>
    </div>
  );
}
